import getApi from '../../../api'
import { ApiErrorContent } from '../../../model/Error'
import { EmailAddressesReponse } from './webservice.model'

export const getAddresses = (headers?: Record<string, string>) =>
  getApi().get<EmailAddressesReponse, ApiErrorContent>(`/mss/email_addresses`, undefined, {
    headers,
  })
